import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface ManualEntry {
  id: string;
  entry_type: 'income' | 'expense';
  folio?: string;
  entry_date: number;
  document_number?: string;
  beneficiary_id?: string;
  beneficiary_external_name?: string;   // ← NUEVO
  beneficiary_type?: 'office' | 'supplier' | 'client' | 'contractor';
  concept_id: string;
  project_id?: string;
  details?: string;
  movement_type_id?: string;
  movement_detail_id?: string;
  amount: number;
  affects_wallet: number;
  department_id?: string;
  currency_type_id?: string;
  status: 'active' | 'reversed';
  reverses_id?: string;
  reversed_by_id?: string;
  created_by: string;
  created_at: number;
  concept_name?: string;
  project_name?: string;
  movement_type_name?: string;
  movement_detail_name?: string;
  department_name?: string;
}

export const manualEntryService = {
  async list(filters?: { entry_type?: string; status?: string }): Promise<ManualEntry[]> {
    const params = new URLSearchParams();
    if (filters?.entry_type) params.append('entry_type', filters.entry_type);
    if (filters?.status) params.append('status', filters.status);
    const q = params.toString();

    const response = await authService.fetchWithAuth(
      `${API_URL}/api/manual-entries${q ? `?${q}` : ''}`
    );
    return response.data || [];
  },

  async get(id: string): Promise<ManualEntry> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/manual-entries/${id}`);
    return response.data;
  },

  async create(data: Partial<ManualEntry>): Promise<ManualEntry> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/manual-entries`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async reverse(id: string, reason?: string): Promise<ManualEntry> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/manual-entries/${id}/reverse`,
      {
        method: 'POST',
        body: JSON.stringify({ reason }),
      }
    );
    return response.data;
  },
};